module.exports = __webpack_public_path__ + "static/media/timer-latest-work.1547e05a.png";